import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'listing-search',
  template: `
    <div class="card-view" color="pink">
      <div class="card-content flow-column no-padding">
        <div class="card-title">
          <h2>{{ 'LISTING_SEARCH_TITLE' | translate }}</h2>
        </div>
        <div class="card-form">
          <form class="search-form">
            <input placeholder="ex.: Restaurante japonês" type="text" [(ngModel)]="search" name="search">
            <button class="search-button" (click)="searchFor(search)"><span class="fa fa-search"></span></button>
          </form>
        </div>
      </div>
    </div>`
})

export class ListingSearchComponent {

  @Input() search;

  constructor(private router: Router) {
  }

  searchFor(value) {
    this.router.navigate(['/listagem'], { queryParams: { search: value } });
  }
}
